import { CheckboxOption } from 'shared/common/ConvertToCheckboxOptions'
import { PaymentStatus } from 'shared/types/Common'

import {
  AdvancedOrdersStatus,
  OrderDetailPaymentStatus,
  OrdersStatus,
} from 'modules/Orders/types'

import { Circle } from 'shared/ui/Circle'

import { palette } from 'shared/config/styles/palette'

export const SortedOrdersStatuses: OrdersStatus = {
  INITIALIZED: {
    title: 'В ожидании',
    color: palette.light_gray_4,
    btnText: 'Принят',
    isBtnDisabled: true,
    changeToStatus: 'ACCEPTED',
  },
  ACCEPTED: {
    title: 'Принят',
    color: palette.pink,
    btnText: 'Готовится',
    isBtnDisabled: true,
    changeToStatus: 'PREPARING',
  },
  PREPARING: {
    title: 'Готовится',
    color: palette.dark_blue_2,
    btnText: 'Ждет курьера',
    isBtnDisabled: true,
    changeToStatus: 'WAITING_FOR_COURIER',
  },
  WAITING_FOR_COURIER: {
    title: 'Ждет курьера / Готов к выдаче',
    color: palette.yellow,
    btnText: 'В пути',
    isBtnDisabled: false,
    changeToStatus: 'ON_THE_WAY',
  },
  ON_THE_WAY: {
    title: 'В пути',
    color: palette.orange,
    btnText: 'Завершить',
    isBtnDisabled: false,
    changeToStatus: 'COMPLETED',
  },
  COMPLETED: {
    title: 'Завершен',
    color: palette.dark_green_1,
    btnText: '',
  },
  CANCELED: {
    title: 'Отменен',
    color: palette.red_2,
    btnText: '',
  },
}

export const adanvcedOrdersStatusKey: AdvancedOrdersStatus = {
  ...SortedOrdersStatuses,
  WAITING_FOR_PAYMENT: {
    title: 'В ожидании оплаты',
    color: palette.light_gray_4,
    btnText: '',
  },
}
export const orderStatusOptions: CheckboxOption[] = [
  {
    label: 'В ожидании',
    value: 'INITIALIZED',
    prefix: (
      <Circle
        size={10}
        color={palette.light_gray_8}
      />
    ),
  },
  {
    label: 'Принят',
    value: 'ACCEPTED',
    prefix: (
      <Circle
        size={10}
        color={palette.pink}
      />
    ),
  },
  {
    label: 'Готовится',
    value: 'PREPARING',
    prefix: (
      <Circle
        size={10}
        color={palette.dark_blue_1}
      />
    ),
  },
  {
    label: 'Ждет курьера',
    value: 'WAITING_FOR_COURIER',
    prefix: (
      <Circle
        size={10}
        color={palette.yellow}
      />
    ),
  },
  {
    label: 'В пути',
    value: 'ON_THE_WAY',
    prefix: (
      <Circle
        size={10}
        color={palette.orange}
      />
    ),
  },
  {
    label: 'Отменен',
    value: 'CANCELED',
    prefix: (
      <Circle
        size={10}
        color={palette.red}
      />
    ),
  },
  {
    label: 'Завершен',
    value: 'COMPLETED',
    prefix: (
      <Circle
        size={10}
        color={palette.green}
      />
    ),
  },
]

export const paymentStatuses = {
  NOT_PAID: {
    title: 'НЕ ОПЛАЧЕНО',
    color: palette.red_4,
  },
  PAID: {
    title: 'ОПЛАЧЕНО',
    color: palette.dark_green_1,
  },
  REFUNDED: {
    title: 'ВОЗВРАТ',
    color: palette.red,
  },
} as { [key in PaymentStatus]: OrderDetailPaymentStatus }
